module.exports = __webpack_public_path__ + "static/media/3@2x.1632da9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/3@2x.png
// module id = 1517
// module chunks = 0